import * as types from "./types";

export const clearStore = () => ({
  type: types.CLEAR_STORE
});

/* Fetch invoice */
export const fetchingInvoiceError = error => ({
  type: types.FETCHING_INVOICE_ERROR,
  payload: error
});

export const fetchingInvoiceSuccess = data => ({
  type: types.FETCHING_INVOICE_SUCCESS,
  payload: data
});

export const fetchInvoice = data => ({
  type: types.FETCHING_INVOICE,
  payload: data
});

export const fetchInvoiceCancel = () => ({
  type: types.FETCHING_INVOICE_CANCEL
});
/* Fetch invoice */

/* Deactivate statement */
export const deactivateStatementError = error => ({
  type: types.DEACTIVATE_STATEMENT_ERROR,
  payload: error
});

export const deactivateStatementSuccess = data => ({
  type: types.DEACTIVATE_STATEMENT_SUCCESS,
  payload: data
});

export const deactivateStatement = statementId => ({
  type: types.DEACTIVATE_STATEMENT,
  payload: statementId
});
/* Deactivate statement */

/* download invoice */
export const downloadInvoiceError = error => ({
  type: types.DOWNLOAD_INVOICE_ERROR,
  payload: error
});

export const downloadInvoiceSuccess = () => ({
  type: types.DOWNLOAD_INVOICE_SUCCESS
});

export const downloadInvoice = (id, lng) => ({
  type: types.DOWNLOAD_INVOICE,
  payload: { id, lng }
});
/* download invoice */

/* print payment */
export const printPaymentError = error => ({
  type: types.PRINT_PAYMENT_ERROR,
  payload: error
});

export const printPaymentSuccess = () => ({
  type: types.PRINT_PAYMENT_SUCCESS
});

export const printPayment = (id, lng) => ({
  type: types.PRINT_PAYMENT,
  payload: { id, lng }
});
/* print payment */

/* go to payment gateway */
export const goToPaymentGatewayError = error => ({
  type: types.GO_TO_PAYMENT_GATEWAY_ERROR,
  payload: error
});

export const goToPaymentGatewaySuccess = () => ({
  type: types.GO_TO_PAYMENT_GATEWAY_SUCCESS
});

export const goToPaymentGateway = invoice => ({
  type: types.GO_TO_PAYMENT_GATEWAY,
  payload: invoice
});
/* go to payment gateway */

export const deleteInvoiceAgent = () => ({
  type: types.DELETE_INVOICE_AGENT
});

export const refreshWebHooks = data => ({
  type: types.REFRESH_WEBHOOK,
  payload: data
});

export const refreshWebHooksError = error => ({
  type: types.REFRESH_WEBHOOK_ERROR,
  payload: error
});

export const refreshWebHooksSuccess = data => ({
  type: types.REFRESH_WEBHOOK_SUCCESS,
  payload: data
});

export const checkWebhookStatus = data => ({
  type: types.CHECK_WEBHOOK_STATUS,
  payload: data
});

export const checkIsVoidAvailable = data => ({
  type: types.CHECK_VOID_AVAILABLE,
  payload: data
});

export const checkVoidAvailableSuccess = data => ({
  type: types.CHECK_VOID_AVAILABLE_SUCCESS,
  payload: data
});

export const voidInvoice = (data, justification) => ({
  type: types.VOID_INVOICE,
  payload: { data, justification }
});

export const checkWebhookStatusError = error => ({
  type: types.CHECK_WEBHOOK_STATUS_ERROR,
  payload: error
});

export const checkWebhookStatusSuccess = data => ({
  type: types.CHECK_WEBHOOK_STATUS_SUCCESS,
  payload: data
});

/* Change invoice status */
export const changeInvoiceStatus = data => ({
  type: types.CHANGE_INVOICE_STATUS,
  payload: data
});

export const changeInvoiceStatusError = error => ({
  type: types.CHANGE_INVOICE_STATUS_ERROR,
  payload: error
});

export const changeInvoiceStatusSuccess = data => ({
  type: types.CHANGE_INVOICE_STATUS_SUCCESS,
  payload: data
});
/* Change invoice status */
